import { alpha } from "@mui/material/styles";

import { ALERT_RED, DARK_SURFACES, OFF_WHITE, marketingLiftSx } from "@/shared/theme";

export const AUTH_KNIGHT_PATH = [
  [0, 0],
  [2, 1],
  [0, 2],
  [1, 0],
  [3, 1],
  [2, 3],
  [1, 1],
  [3, 0],
  [2, 2],
  [0, 1],
  [1, 3],
  [3, 2],
  [2, 0],
  [1, 2],
] as const;
export const authKnightTransform = ([file, rank]: readonly [number, number]) =>
  `translate(${file * 100}%, ${rank * 100}%)`;
export const AUTH_KNIGHT_FRAMES: Record<string, { transform: string }> = {};
AUTH_KNIGHT_PATH.forEach((square, index) => {
  AUTH_KNIGHT_FRAMES[`${(index / AUTH_KNIGHT_PATH.length) * 100}%`] = { transform: authKnightTransform(square) };
});
AUTH_KNIGHT_FRAMES["100%"] = { transform: authKnightTransform(AUTH_KNIGHT_PATH[0]) };
export const AUTH_KNIGHT_ANIMATION = "authKnightMove 9.8s step-end infinite";

const AUTH_MUTED_TEXT = alpha(DARK_SURFACES.canvas, 0.72);
const AUTH_DISABLED_TEXT = alpha(DARK_SURFACES.canvas, 0.62);

export const authMutedTextSx = { color: AUTH_MUTED_TEXT } as const;

export const authLinkSx = {
  color: ALERT_RED.dark,
  fontWeight: 900,
  textDecoration: "underline",
  textUnderlineOffset: 4,
} as const;

export const authCheckboxSx = {
  color: DARK_SURFACES.canvas,
  "&.Mui-checked": { color: ALERT_RED.main },
  "&.Mui-disabled": { color: AUTH_DISABLED_TEXT },
} as const;

export const authFormControlLabelSx = {
  alignItems: "flex-start",
  color: AUTH_MUTED_TEXT,
  display: "flex",
  m: 0,
  mb: 1.5,
  width: "100%",
  "& .MuiFormControlLabel-label": {
    fontSize: "0.72rem",
    lineHeight: 1.5,
    pt: "7px",
  },
} as const;

export const authFeedbackSx = {
  borderRadius: 0,
  color: DARK_SURFACES.canvas,
  mb: 2,
  "& .MuiAlert-message": { color: DARK_SURFACES.canvas },
} as const;

export const authFooterSx = {
  ...authMutedTextSx,
  borderTop: `1px solid ${DARK_SURFACES.canvas}`,
  display: "block",
  mt: 4,
  pt: 3,
} as const;

export const authFieldSx = {
  mb: 2.25,
  "& .MuiInputLabel-root": { color: DARK_SURFACES.canvas, fontSize: 13, fontWeight: 800 },
  "& .MuiInputLabel-root.Mui-focused": { color: ALERT_RED.dark },
  "& .MuiInputLabel-root.Mui-disabled": { color: AUTH_DISABLED_TEXT },
  "& .MuiInputBase-input": {
    color: DARK_SURFACES.canvas,
    caretColor: ALERT_RED.main,
    WebkitTextFillColor: DARK_SURFACES.canvas,
  },
  "& .MuiInputAdornment-root, & .MuiIconButton-root": { color: DARK_SURFACES.canvas },
  "& .MuiFormHelperText-root": { color: AUTH_MUTED_TEXT },
  "& .MuiFormHelperText-root.Mui-error": { color: ALERT_RED.dark },
  "& input:-webkit-autofill": {
    WebkitBoxShadow: `0 0 0 100px ${OFF_WHITE.light} inset`,
    WebkitTextFillColor: DARK_SURFACES.canvas,
  },
  "& .MuiOutlinedInput-root": {
    bgcolor: OFF_WHITE.light,
    borderRadius: 0,
    minHeight: 52,
    "& fieldset": { borderColor: DARK_SURFACES.canvas, borderWidth: 1 },
    "&:hover fieldset": { borderColor: ALERT_RED.main },
    "&.Mui-focused fieldset": { borderColor: ALERT_RED.main, borderWidth: 2 },
    "&.Mui-disabled": { bgcolor: OFF_WHITE.dark },
  },
  "& .MuiInputBase-input.Mui-disabled": { WebkitTextFillColor: DARK_SURFACES.canvas },
} as const;

export const authPrimaryActionSx = {
  bgcolor: ALERT_RED.main,
  border: `2px solid ${DARK_SURFACES.canvas}`,
  borderRadius: 0,
  boxShadow: "none",
  color: DARK_SURFACES.canvas,
  fontWeight: 950,
  minHeight: 52,
  width: "100%",
  ...marketingLiftSx(DARK_SURFACES.canvas),
  "&:hover, &:focus-visible": {
    ...marketingLiftSx(DARK_SURFACES.canvas)["&:hover, &:focus-visible"],
    bgcolor: ALERT_RED.main,
  },
  "&:focus-visible": { outline: `3px solid ${DARK_SURFACES.canvas}`, outlineOffset: 3 },
  "&.Mui-disabled": { bgcolor: OFF_WHITE.dark, color: DARK_SURFACES.canvas, opacity: 1 },
} as const;
